import { flatMap, get, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
//import { v4 as uuidv4 } from "uuid";
import api from "../../apis/axiosInterceptor";
import { HTTPS } from "../../shared/constants";
import { generateUniqId } from "../../shared/functions";

interface SubTags {
  subtagData: object;
  curSubTagsEditData: any;
  totalPageCount: number;
  totalData: number;
  error: string;
}

const initialArgs: SubTags = {
  subtagData: [],
  curSubTagsEditData: {},
  totalPageCount: 0,
  totalData: 17,
  error: "",
};

const reducer = (state: SubTags, action: SubTags) => {
  return { ...state, ...action };
};

const useSubTags = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getSubTags = async (
    page: string,
    pageSize: string,
    searchText: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/v1/questionnaires/subTags?page=${page}&pageSize=${pageSize}&searchValue=${searchText}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          subtagData: result.data.data.data,
          totalPageCount: get(result, "data.data.totalPageCount", 0),
          totalData: get(result, "data.data.totalData", 0),
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createSubTags = async (param: any) => {
    const paramObj = {
      ...param,
      id: generateUniqId(),
    };
    try {
      const result: any = await api.post(
        "/api/v1/questionnaires/subTags",
        paramObj,
      );

      if (result.data.status) {
        toast.success("SubTag has been Added Successfully");
        setState({ ...state, subtagData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //Edit
  const editSubTags = async (id: string) => {
    try {
      const result: any = await api.get(`/api/v1/questionnaires/subTags/${id}`);

      if (result.data.status) {
        setState({ ...state, curSubTagsEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  //For Update
  const updateSubTags = async (param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.post(
        `/api/v1/questionnaires/subTags/${param.id}`,
        paramObj,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const deleteSubTags = async (id: number) => {
    try {
      const { status } = await api.delete(
        `/api/v1/questionnaires/subTags/delete?id=${id}`,
      );

      if (status === HTTPS.OK) {
        toast.success("SubTag has been deleted successfully");
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      toast.error("Error while deleting SubTag");
      return false;
    }
  };
  return {
    getSubTags,
    createSubTags,
    editSubTags,
    updateSubTags,
    deleteSubTags,
    ...state,
  };
};

export default useSubTags;
